/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * The record's state after closing. Null when nothing about the lifecycle changed.
 */
export enum EventRecordStatus {
  AWAITING_ACKNOWLEDGEMENT = "AWAITING_ACKNOWLEDGEMENT",
  IN_PROGRESS = "IN_PROGRESS",
  RESOLVED = "RESOLVED",
  ARCHIVED = "ARCHIVED",
}
